/**
 * external 프리셋 — 검색/제안서/키비주얼/3D 등 외부·자료형 화면 전용.
 *
 * 기존에 각 화면에 흩어져 있던 Toss식 card/chip 상수를 이곳으로 이동했다.
 * Toss 전용 디자인 시스템으로 분리한 것은 아니다.
 * 목적은 "각 화면의 개성은 유지하되 색상, radius, shadow, chip 상태는 사내 관리 화면 기준으로 통일"이다.
 */
export const createExternalPresets = (tokens) => ({
    // 외부/자료형 페이지의 기본 바탕. py: 3은 상하 24px 여백이다.
    page: {
        minHeight: "100vh",
        // bgcolor: tokens.colors.bg,
        py: 3,
    },
    // 외부/자료형 페이지의 큰 제목. 기본 pageTitle보다 2px 크게 둔다.
    heroTitle: {
        ...tokens.typography.pageTitle,
        fontSize: 22,
        fontWeight: 800,
    },
    // heroTitle 아래 설명. mt: 0.5는 위쪽 4px 간격이다.
    heroSubtitle: {
        ...tokens.typography.pageSubtitle,
        mt: 0.5,
    },
    // 기존 Toss식 카드의 대체값. shadow는 약하게 해서 사내 관리 화면과 맞춘다.
    card: {
        bgcolor: tokens.colors.surface,
        border: `1px solid ${tokens.colors.border}`,
        borderRadius: 1.5,
        boxShadow: "0 2px 8px rgba(15, 23, 42, 0.06)",
        backgroundImage: "none",
    },
    // 더 떠 보이는 카드. 모달 옆 패널, 상세/유사목록처럼 강조가 필요한 영역에 쓴다.
    cardElevated: {
        bgcolor: tokens.colors.surface,
        border: `1px solid ${tokens.colors.border}`,
        borderRadius: 1.5,
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.08)",
        backgroundImage: "none",
    },
    // 표 스타일(tableContainer/tableHead/tableBody/tableRowHover)은 presets/table.js 로 이관됨.
    // 사용처: ds.components.table / ds.components.tableContainer / ds.components.tableHead 등.

    // 기본 칩. 필터 옵션, 비활성 키워드, 보조 라벨에 쓴다.
    chip: {
        borderRadius: 1.5,
        height: 28,
        border: `1px solid ${tokens.colors.border}`,
        bgcolor: tokens.colors.bg,
        "& .MuiChip-label": {
            fontSize: 12,
            fontWeight: 600,
            color: tokens.colors.textSecondary,
            px: 1,
        },
        "&:hover": {
            bgcolor: tokens.colors.borderLight,
        },
    },
    // 활성 칩. 선택된 키워드/필터에 쓴다.
    chipActive: {
        borderRadius: 1.5,
        height: 28,
        border: `1px solid ${tokens.colors.primaryBorder}`,
        bgcolor: tokens.colors.primaryLight,
        color: tokens.colors.primary,
        "& .MuiChip-label": {
            fontSize: 12,
            fontWeight: 700,
            color: tokens.colors.primary,
            px: 1,
        },
        "&:hover": {
            bgcolor: tokens.colors.primaryBg,
        },
    },
    // 성공/테마 성격 칩. 초록 계열 의미가 필요한 경우에 쓴다.
    chipSuccess: {
        borderRadius: 1.5,
        height: 28,
        border: "1px solid #86efac",
        bgcolor: tokens.colors.successBg,
        color: "#166534",
        "& .MuiChip-label": {
            fontSize: 12,
            fontWeight: 700,
            color: "#166534",
            px: 1,
        },
        "&:hover": {
            bgcolor: "#dcfce7",
        },
    },
    // 둥근 버튼 공통값. Button variant/color는 각 화면에서 유지하고 모양만 통일한다.
    pillButton: {
        borderRadius: 1.5,
        fontWeight: 600,
    },
    // 연한 배경 입력창. 검색/필터 입력처럼 카드 안에 들어가는 입력에 쓴다.
    inputSoft: {
        "& .MuiOutlinedInput-root": {
            borderRadius: 1.5,
            bgcolor: tokens.colors.bg,
        },
    },
    // 이미지/문서/포스터 카드. hover 시 살짝 떠서 클릭 가능함을 보여준다.
    contentCard: {
        overflow: "hidden",
        cursor: "pointer",
        transition: "transform 150ms ease, box-shadow 150ms ease, border-color 150ms ease",
        "&:hover": {
            transform: "translateY(-2px)",
            borderColor: tokens.colors.primaryBorder,
            boxShadow: "0 8px 24px rgba(15, 23, 42, 0.10)",
        },
    },
    // 썸네일 영역. 이미지가 없을 때도 같은 면 색과 하단 경계를 유지한다.
    thumbnail: {
        bgcolor: tokens.colors.bg,
        borderBottom: `1px solid ${tokens.colors.border}`,
        overflow: "hidden",
    },
});
